module.exports = __webpack_public_path__ + "static/devteam_03-70d7ad52b93d43165980c92e1c14aa51.jpg";